import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/discount_settlements',
  component: Management,
  redirect: '/discount_settlements/list',
  children: [
    // 详情
    {
      path: ':id',
      component: () => import('@/views/discount_settlements/DetailLayout'),
      meta: {
        auth: Auth.showOrderDiscountSettlements,
        activeMenu: '/ev_charging_station_settlements'
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/discount_settlements/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showOrderDiscountSettlements,
            activeMenu: '/ev_charging_station_settlements'
          }
        }
      ]
    }
  ]
}
